import { render, staticRenderFns } from "./InfoServicePacks.vue?vue&type=template&id=31ec241e&scoped=true"
import script from "./InfoServicePacks.vue?vue&type=script&lang=js"
export * from "./InfoServicePacks.vue?vue&type=script&lang=js"
import style0 from "./InfoServicePacks.vue?vue&type=style&index=0&id=31ec241e&prod&scoped=true&lang=css"
import style1 from "./InfoServicePacks.vue?vue&type=style&index=1&id=31ec241e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ec241e",
  null
  
)

export default component.exports